/* eslint-disable import/no-internal-modules */
import type {
  GetEventsInput,
  Maybe,
  SearchableScheduledEventFilterInput,
  SearchableScheduledEventSortInput
} from '../../../graphql-types';
import {
  EventType,
  EventVisibility,
  SearchableScheduledEventSortableFields,
  SearchableSortDirection
} from '../../../graphql-types';
import type { GetEventsQuery, GetEventsQueryVariables, GetUntitledEventsQuery } from './__generated__/use-events';

type ScheduledEvent = Exclude<
  Exclude<GetEventsQuery['getEvents'], undefined>['result'][0],
  undefined
>;

type UntitledEvent = Exclude<
  Exclude<GetUntitledEventsQuery['getLiveAssets'], undefined>['assets'][0],
  undefined
>;

export type {
  GetEventsInput,
  GetEventsQuery,
  GetEventsQueryVariables,
  ScheduledEvent,
  UntitledEvent,
  SearchableScheduledEventSortInput,
  SearchableScheduledEventFilterInput,
  Maybe
};

// Appsync Enums.
export {
  SearchableScheduledEventSortableFields,
  SearchableSortDirection,
  EventType,
  EventVisibility
};
